import { render, staticRenderFns } from "./WxNews.vue?vue&type=template&id=79b503c6&scoped=true"
import script from "./WxNews.vue?vue&type=script&lang=js"
export * from "./WxNews.vue?vue&type=script&lang=js"
import style0 from "./WxNews.vue?vue&type=style&index=0&id=79b503c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b503c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b503c6')) {
      api.createRecord('79b503c6', component.options)
    } else {
      api.reload('79b503c6', component.options)
    }
    module.hot.accept("./WxNews.vue?vue&type=template&id=79b503c6&scoped=true", function () {
      api.rerender('79b503c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wechat/WxNews.vue"
export default component.exports